<template>
  <vx-card>

    <!-- Img Row -->
    <!-- <div class="flex flex-wrap items-center mb-base">
      <vs-avatar :src="activeUserInfo.photoURL" size="70px" class="mr-4 mb-4" />
      <div>
        <p class="text-sm mt-2">Somebody here</p>
      </div>
    </div> -->

    <!-- Info -->
    <vs-input class="w-full mb-base" label-placeholder="First Name" v-model="user.details.first_name"></vs-input>
    <vs-input class="w-full mb-base" label-placeholder="Last Name" v-model="user.details.last_name"></vs-input>
    <vs-input class="w-full" label-placeholder="Email" disabled v-model="user.email"></vs-input>

    <div class="mt-8 mb-base">
      <label class="text-sm">Gender</label>
      <div class="mt-2">
        <vs-radio v-model="user.details.gender" vs-value="Male" class="mr-4">Male</vs-radio>
        <vs-radio v-model="user.details.gender" vs-value="Female" class="mr-4">Female</vs-radio>
      </div>
    </div>

    <div class="mt-8 mb-base">
      <label class="text-sm">Phone Number</label>
      <div>
        <vx-input-group>
          <template slot="prepend">
              <div class="prepend-text bg-primary">
              <span>+60</span>
              </div>
          </template>

          <vs-input
            v-validate="'min:9|max:10|numeric|required'"
            data-vv-validate-on="blur"
            name="phone number"
            v-model="user.details.phone_number"
            class="w-full"/>
        </vx-input-group>
        <span class="text-danger text-sm float-left">{{ errors.first('phone number') }}</span>
      </div>
    </div>

     <div class="mt-8">
      <label class="text-sm">Birth Date</label>
        <flat-pickr v-model="user.details.dob" :config="{ dateFormat: 'Y-m-d' }" class="w-full" />
    </div>

    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" :disabled="!changesMade" @click="saveChanges">Save Changes</vs-button>
    </div>
  </vx-card>
</template>

<script>
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import axios from '@/axios'

export default {
  components: {
    flatPickr,
    vSelect
  },
  data () {
    return {
      user: {}
    }
  },
  created(){
    this.user = _.cloneDeep(this.$store.state.user)
    this.user.details.phone_number = this.user.details.phone_number.substring(3,this.user.details.phone_number.length)
  },
  computed: {
    changesMade() {
      return this.user.details.first_name !== this.$store.state.user.details.first_name || 
      this.user.details.last_name !== this.$store.state.user.details.last_name ||  
      this.user.details.phone_number !== this.$store.state.user.details.phone_number.substring(3,this.$store.state.user.details.phone_number.length) ||
      this.user.details.gender !== this.$store.state.user.details.gender || 
      this.user.details.dob !== this.$store.state.user.details.dob
    }
  },
  methods:{
   async saveChanges() {
     let keys = ['first_name','last_name','gender','phone_number','dob'], payload = {}

     for(let key of keys){
       if(this.user.details[key] !== this.$store.state.user.details[key]){
         if(key === 'phone_number'){
           Object.assign(payload,{[key]: '+60'+this.user.details[key]})
         }else {
          Object.assign(payload,{[key]: this.user.details[key]})
        }
       }
     }

     if(Object.keys(payload).length !== 0){
       await axios.patch(`/user/${this.user.id}/detail`,payload)
       .then(() => {
        this.$vs.notify({
          title: 'Success',
          text: 'User Details Updated Successful!',
          iconPack: 'feather',
          icon: 'icon-check',
          color: 'success'	
			  })
       })
       .catch(() => {
         this.$vs.notify({
          title: 'Oops',
          text: 'The details cannot update at this moment.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'		
				})
       })
     }  
    }
  }
}
</script>

<style scoped>
.date-picker{
  z-index: 62000;
}
</style>
